module.exports = __webpack_public_path__ + "static/img/Aions_Mar_8.5374cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_8.png
// module id = r4Bk
// module chunks = 19